function ProfileFooter() {
  return (
    <div className="text-center mt-8">
      <p className="text-gray-500">
        Day 1 - JSX & Components
      </p>
    </div>
  );
}

export default ProfileFooter;